export class CommonDataModel {

    contactFormModel = {
        account: null,
        accountTypeId: null,
        contactTypeId: 2,
        firstName: null,
        middleName: null,
        lastName: null,
        email: null,
        primaryPhone: null,
        isInternationalPhone: false,
        primaryExt: null,
        address: null,
        linkedAddressId: null,
        contactNumberList: [],
        accountId: null,
    };

    contactListParamsModel = {
        accountId: null,
        id: null,
        accountTypeId: null,
        accountName: null,
        activeStatus: false
    };

    contactPhoneListModel = {
        phoneTypeId: 2,
        phoneNumber: null,
        phoneExtension: null
    };

    phoneTypeList = [
        { id: 2, text: 'Office Phone' },
        { id: 3, text: 'Other' },
        { id: 4, text: 'Fax' }
    ];

    contactStatusModel = {
        contactId: null,
        isActive: true
    };

    addressesStatusUpdateModel = {
        addresses: [],
        accountId: null,
        isActive: null
    };

    notesFormModel = {
        notes: null,
        vehicleId: null
    };

    notesModel = {
        vehicleId: null,
        vehicleNoteId: null
    };

    leadAccountAddFormModel = {
        isIndividualAccount: null,
        accountName: null,
        notes: null,
        isCustomer: false,
        isRfqAccount: false,
        quickAccount: false,
        accountDetails: {
            leadSourceId: null,
            industryId: null,
            accountStatusId: null,
        },
        contact: {
            contactTypeId: 1,
            firstName: null,
            middleName: null,
            lastName: null,
            email: null,
            primaryPhone: null,
            isInternationalPhone: false,
            primaryExt: null,
            contactNumberList: [],
            primaryCountryCode: null
        },
        address: {
            addressLine1: null,
            addressLine2: null,
            fullAddress: null,
            city: null,
            provinceId: null,
            zipCode: null,
            countryId: null,
            addressIndicator: '1',
            customeAddressTypeInfo: null,
            addressTypeId: 1
        },
    };

    addressFieldsModel = {
        addressLine1: null,
        addressLine2: null,
        city: null,
        provinceId: null,
        zipCode: null,
        countryId: null,
        addressTypeId: 1,
        customeAddressTypeInfo: null,
        addressIndicator: '1'
    };

    // start orders
    shippingCustomAddressModel = {
        addressLine1: null,
        addressLine2: null,
        accountName: null,
        shippingInfoId: null,
        name: null,
        email: null,
        phone: null,
        zipCode: null,
        isActive: false,
        shippingType: null,
        contactId: null,
        provinceName: null,
        city: null,
        countryName: null,
        isInternational: false,
        isInternationalPhone: false,
        contactName: null,
        accountId: null,
        isQuickContact: null,
        addressId: null,
        accountNotes: null,
        addressIndicator: null,
        primaryExt: null
    };

    ordersContactModel = {
        accountId: null,
        name: null,
        email: null,
        phone: null,
        zipCode: null,
        isInternational: false,
        isInternationalPhone: false
    };

    shippingAddressModel = {
        shippingInfoId: null,
        address: null,
        addressId: null,
        name: null,
        email: null,
        phoneNumber: null,
        zipCode: null,
        isQuickContact: false,
        customZipCode: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        provinceName: null,
        countryName: null,
        contactId: null,
        accountName: null,
        accountId: null,
        accountTypeId: null,
        addressIndicator: null,
        contactName: null,
        isChanged: false,
        ownedByTenant: '',
        distance: '',
        isShipperAddress: false,
        accountNotes: '',
        isConsigneeAddress: false,
        primaryExt: null
    };

    getQuoteRequestModel = {
        carriers: [],
        shipper: {
            city: null,
            state: null,
            zipcode: null,
            readyTime: null,
            closeTime: null
        },
        consignee: {
            city: null,
            state: null,
            zipcode: null,
            readyTime: null,
            closeTime: null
        },
        totalWeight: null,
        serviceClass: null,
        packageType: null,
        pickupDate: null,
        deliveryDate: null,
        items: [],
        accessorials: [],
        itemCount: null,
        currentQuote: {
            id: null,
            pickupDate: null,
            shipFromReadyTime: null,
            shipFromCloseTime: null,
            shipToOpenTime: null,
            shipToCloseTime: null
        },
        originLocationType: {
            id: 0,
            name: '',
            description: ''
        },
        destinationLocationType: {
            id: 0,
            name: '',
            description: ''
        }
    };

    carrierCostsListModel = {
        dimWeightFactorId: 194,
        carrierCostId: null,
        carrierId: null,
        serviceName: null,
        serviceDate: null,
        shippingCost: null,
        carrierName: null,
        pro: null,
        transitDays: null
    };

    carrierCostsTotalsModel = {
        unitWeightOverallTotal: 0,
        extWeightOverallTotal: 0,
        unitDimWeightOverallTotal: 0,
        extDimWeightOverallTotal: 0,
        // lbsByCubicFeet: 0,
        unitCuFeOverallTotal: 0,
        lbsByCuFeOverallTotal: 0,
        extCuFeOverallTotal: 0,
        totalQuantity: 0
    };

    insuranceModel = {
        insuranceRateId: 0,
        orderInsuranceId: null,
        insuranceRateLongId: null,
        insuranceProviderId: null,
        insuranceProviderLongId: null,
        coverage_Rate: 0,
        markupPercentage: 0,
        minimum_Charge: 0,
        tierId: null,
        excessValueThreshold: null,
        isChanged: false
    };

    serviceListObjectModel = {
        revenueCategoryId: null,
        serviceId: null,
        serviceName: null,
        description: null,
        cost: 0.00,
        quantity: 1,
        subTotal: 0.00,
        markupPercentage: 0,
        marginPercentage: 0,
        isTaxable: null,
        tax: 0,
        total: 0.00,
        markUp: 0.00,
        isActive: true,
        detailedDescription: null,
        byAccount: false
    };

    quickQuoteItem = {
        quantity: null,
        categoryId: null,
        categoryName: null,
        itemId: null,
        itemName: null,
        description: null,
        length: null,
        width: null,
        height: null,
        weight: null,
        value: null,
        extlbs: null,
        extValue: null,
        nmfcClass: null,
        isOrientationLocked: null,
        isActive: true,
        isChanged: false,
        preTime: null
    };

    containerTotalsModel = {
        idl: 0,
        idw: 0,
        idh: 0,
        totalEXTLBS: 0,
        totalEXTValue: 0
    };

    containerInnerDimentionsModel = {
        height: 0,
        width: 0,
        length: 0,
    };

    quickQuoteContainerModel = {
        itemContainerId: null,
        containerName: null,
        containerNumber: null,
        quantity: null,
        containerId: null,
        packagingId: null,
        description: null,
        lineItems: [this.quickQuoteItem],
        containerTotals: Object.assign({}, this.containerTotalsModel),
        tempContainerId: null,
        isExpanded: false,
        idl: null,
        idh: null,
        idw: null,
        isIDLUserChanged: false,
        isIDHUserChanged: false,
        isIDWUserChanged: false,
        isFixedCost: false
    };

    boxContainerFormModel = {
        containerId: null,
        containerCategoryId: null,
        containerCategoryName: null,
        containerStyleId: null,
        containerStyleName: null,
        baseContainerId: null,
        baseContainerName: null,
        templateContainerId: null,
        containerName: null,
        containerDescription: null,
        defaultLabourMethod: null,
        customFixedLabour: null,
        minimumMinutes: null,
        isStockContainer: false,
        isActive: null,
        containerDetails: {
            containerDetailId: null,
            containerId: null,
            floaterId: null,
            palletId: null,
            bottomDeckBoardId: null,
            gussetsId: null,
            fullPerpendicularRubStripsId: null,
            floaterGId: null,
            palletGId: null,
            bottomDeckBoardGId: null,
            gussetsGId: null,
            fullPerpendicularRubStripsGId: null,
            cleatsId: null,
            plywoodId: null,
            skidOrientId: null,
            notes: null
        },
        containerMaterials: [],
        laborTiers: []
    };

    ordersMaterialPostModel = {
        containerMaterialId: null,
        containerId: null,
        faceId: null,
        faceName: null,
        materialId: null,
        materialName: null,
        componentId: null,
        componentName: null,
        materialCategoryId: null,
        materialCategoryName: null,
        containerStyleId: null,
        quantity: null,
        length: null,
        width: null,
        height: null,
        weight: null,
        unitCost: null,
        notes: null,
        isActive: null,
        isStockMaterial: null,
        tempId: null,
        wasteFactor: null,
        defaultWasteFactor: null,
        defaultTotalCost: null,
        cMaterialId: 0
    };
    containerMaterialPostModel = {
        containerMaterialId: null,
        containerId: null,
        faceId: null,
        faceName: null,
        materialId: null,
        materialName: null,
        componentId: null,
        componentName: null,
        materialCategoryId: null,
        materialCategoryName: null,
        containerStyleId: null,
        quantity: null,
        length: null,
        width: null,
        height: null,
        weight: null,
        unitCost: null,
        unitWeight: null,
        notes: null,
        isActive: null,
        isStockMaterial: null,
        tempId: null,
        wasteFactor: null,
        baseContainerId: null,
        modifiersId: null,
        unitId: null,
        staticLoad: null,
        cMaterialId: 0
    };

    defauldGridDataModel = {
        faceId: 10,
        faceName: 'Other',
        containerStyleId: 1,
        materialCategoryId: 1,
        materialId: null,
        materialName: null,
        componentName: 'Custom',
        isCustom: true,
        componentId: 14,
        quantity: 1,
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        unitCost: 0,
        notes: '',
        tempId: null,
        isStockMaterial: false,
        wasteFactor: 0,
        unitId: null,
        staticLoad: null,
        totalCost: 0,
        baseContainerId: null,
        modifiersId: null,
        addTolaborCost: null,
        laborMinutesPer: null,
        skidOrientation: false,
        defaultQuantity: false,
        defaultLength: false,
        defaultWidth: false,
        defaultHeight: false,
        faceSortOrder: 0,
        componentSortOrder: 0,
        nonStdLabor: null,
        defaultWasteFactor: 0,
        defaultTotalCost: 0
    };
    // end orders

    addressFormListModel = {
        accountId: null,
        addressLine1: null,
        addressLine2: null,
        fullAddress: null,
        city: null,
        provinceId: null,
        zipCode: null,
        zip: null,
        countryId: null,
        addressTypeId: null,
        customeAddressTypeInfo: null,
        addressIndicator: '1',
        primaryAccountId: null
    };

    floaterSpacingModel = {
        endOne: 2,
        endTwo: 2,
        sideOne: 2,
        sideTwo: 2,
        top: 2,
        bottom: 0,
        floaterSpacingId: null,
        itemContainerId: null,
        orderId: null
    };

    itemSpacingModel = {
        isEndOne: false,
        endOne: 0,
        isEndtwo: false,
        endtwo: 0,
        isSideOne: false,
        sideOne: 0,
        isSideTwo: false,
        sideTwo: 0,
        isTop: false,
        top: 0,
        isBottom: false,
        bottom: 0
    };

    dimensionModel = {
        length: 0,
        width: 0,
        height: 0,
        weight: 0
    };

    itemContainerSummaryModel = {
        volumeCubicFeet: 0,
        linearFeet: 0,
        cuts: 0,
        fastenerCost: 0,
        boardFeet: 0,
        totalMaterialCost: 0,
        isCustom: false,
        isChanged: false
    };

    laborCalculationModel = {
        volumeMinutes: 0,
        volumeLabor: 0,
        cutsLinearMinutes: 0,
        cutsLinearLabor: 0,
        modifiersLaborCost: 0,
        isChanged: false
    };

    modifiersLaborCalculationModel = {
        volumeMinutes: 0,
        volumeLabor: 0,
        cutsLinearMinutes: 0,
        cutsLinearLabor: 0,
        modifiersLaborCost: 0,
        isCustom: false,
        isChanged: false
    };

    itemContainerLaborModel = {
        costMethodId: 0,
        costMethod: null,
        containerLaborCost: 0,
        prepLaborCost: 0,
        minimumLabor: 0,
        totalLaborCost: 0,
        customMinutes: 0,
        isChanged: false,
        customFixedLabour: 0
    };

    containerDimentionsModel = {
        itemContainerId: null,
        itemDetailsId: null,
        innerDimension: Object.assign({}, this.dimensionModel),
        outerDimension: Object.assign({}, this.dimensionModel),
        itemContainerSummary: this.itemContainerSummaryModel,
        laborCalculation: this.laborCalculationModel,
        modifiersLaborCalculation: this.modifiersLaborCalculationModel,
        itemContainerLabor: this.itemContainerLaborModel
    };

    faceDetailsModel = {
        isActive: false,
        length: null,
        width: null,
        quantity: null,
        faceId: null,
        spacingId: null,
        packagingId: null,
        packagingMaterialId: null,
        materialId: null,
        materialName: null,
        isIncluded: null
    };

    facesModel = {
        end1: Object.assign({}, this.faceDetailsModel),
        end2: Object.assign({}, this.faceDetailsModel),
        side1: Object.assign({}, this.faceDetailsModel),
        side2: Object.assign({}, this.faceDetailsModel),
        top: Object.assign({}, this.faceDetailsModel),
        bottom: Object.assign({}, this.faceDetailsModel)
    };

    containerMaterialModel = {
        isCushioningIncluded: true,
        categoryId: null,
        materialId: null,
        materialName: null,
        unitQuantity: 0.0,
        unit: null,
        unitId: null,
        unitCost: 0.0,
        quantity: 0,
        wasteFactor: 0,
        height: 0.0,
        cost: 0.0,
        unitWeight: 0.0,
        weightLBS: 0.0,
        description: null,
        nonSideLabor: null,
        cushioningDetails: null,
        laborMinutesPer: null,
        addTolaborCost: null,
        isActive: true,
        isChanged: false,
        defaultMaterialList: [],
        nonStdLabor: null,
        layerOrder: null,
        defaultWasteFactor: 0,
        defaultTotalCost: 0,
        isCustomCushioning: false
    };

    calculationBreakUpsModel = {
        floater: null,
        pallet: null,
        bottomDeckBoard: null,
        gussets: null
    };

    modifiersCalBreakUpsModel = {
        volumeMinutes: Object.assign({}, this.calculationBreakUpsModel),
        volumeLabor: Object.assign({}, this.calculationBreakUpsModel),
        cutsLinearMinutes: Object.assign({}, this.calculationBreakUpsModel),
        cutsLinearLabor: Object.assign({}, this.calculationBreakUpsModel),
        laborCost: Object.assign({}, this.calculationBreakUpsModel)
    };

    emailFormModel = {
        to: '',
        cc: '',
        bcc: '',
        subject: '',
        body: '',
        bccToMyself: false,
        toMyself: false,
        orderId: 0
    };

    houseBillingFormModel = {
        houseBillTypeId: 1,
        houseBillTotal: 1,
        emailDetails: this.emailFormModel,
        isview: false,
        isSendEmail: false,
        orderId: null,
        pickupDate: null,
    };

    cutSheetFormModel = {
        emailDetails: this.emailFormModel,
        isSendEmail: false,
        isShowImage: false,
        isview: false,
        orderId: null
    };

    bolFormModel = {
        emailDetails: this.emailFormModel,
        isIntermediary: false,
        isview: false,
        isSendEmail: false,
        orderId: null,
        isJob: false,
        isFv: false,
        isBol: false,
        isFvBol: false,
        fvBolUrl: false,
    };

    requestForPriceFormModel = {
        emailDetails: this.emailFormModel,
        isview: false,
        isSendEmail: false,
        orderId: null,
        notes: '',
        isReceive: false,
        isUnpack: false,
        isDeliver: false,
        tenantId: null
    };

    notificationOfArrivalFormModel = {
        emailDetails: this.emailFormModel,
        isview: false,
        isSendEmail: false,
        orderId: null,
        notes: '',
        isReceive: false,
        isUnpack: false,
        isDeliver: false,
        tenantId: null
    };

    shippingFormModel = {
        emailDetails: this.emailFormModel,
        isSendEmail: false,
        isIntermediary: false,
        shippingLabel: null,
        orderId: null,
        isview: false
    };

    invoiceFormModel = {
        emailDetails: this.emailFormModel,
        isSendEmail: false,
        isItemised: true,
        orderId: null,
        isview: false,
        invoiceDate: null,
    };

    quoteFormModel = {
        documentType: 'Quote',
        emailDetails: this.emailFormModel,
        isview: false,
        isSendEmail: false,
        orderId: null,
        notes: null
    };

    quoteDocumentTypes = [
        {
            name: 'Quote',
            value: 'Quote'
        },
        {
            name: 'Estimate',
            value: 'Estimate'
        }
    ];

    QuoteTotalItemsModel = {
        breakdownId: null,
        orderId: null,
        isLock: null,
        isIncluded: null,
        isTaxable: null,
        categoryId: null,
        categoryName: null,
        cost: null,
        subTotal: null,
        markupValue: null,
        markupPercentage: null,
        marginPercentage: null,
        tax: null,
        total: null
    };

    insuranceBreakdownModel = {
        breakDownId: null,
        categoryId: null,
        categoryName: null,
        insuranceValue: null,
        insuranceCost: null
    };

    categoryBreakdownModel = {
        quotesTotals: [Object.assign({}, this.QuoteTotalItemsModel)],
        overallCost: null,
        overallMarkupValue: null,
        overallMarkupPercentage: null,
        overallMarginPercentage: null,
        overallTax: null,
        overallTotal: null,
    };

    OrderTotalsModel = {
        categoryBreakdown: Object.assign({}, this.categoryBreakdownModel),
        insuranceBreakdown: [Object.assign({}, this.insuranceBreakdownModel)]
    };

    updatePackagingModel = {
        orderId: 0,
        itemContainerId: 0,
        containerId: 0,
        packagingId: 0,
        markupPercentage: 0,
        coverageRate: 0,
        innerDimension: {
            length: 0,
            width: 0,
            height: 0,
            weight: 0
        },
        outerDimension: {
            length: 0,
            width: 0,
            height: 0,
            weight: 0
        },
        itemContainerSummary: {
            volumeCubicFeet: 0,
            linearFeet: 0,
            cuts: 0,
            fastenerCost: 0,
            boardFeet: 0,
            totalMaterialCost: 0,
            isCustom: true
        },
        laborCalculation: {
            volumeMinutes: 0,
            volumeLabor: 0,
            cutsLinearMinutes: 0,
            cutsLinearLabor: 0,
            modifiersLaborCost: 0,
            isCustom: true
        },
        modifiersLaborCalculation: {
            volumeMinutes: 0,
            volumeLabor: 0,
            cutsLinearMinutes: 0,
            cutsLinearLabor: 0,
            modifiersLaborCost: 0,
            isCustom: true
        },
        itemContainerLabor: {
            costMethodId: 0,
            costMethod: 'string',
            containerLaborCost: 0,
            prepLaborCost: 0,
            minimumLabor: 0,
            totalLaborCost: 0,
            customMinutes: 0
        },
        packaging: {
            id: 0,
            name: 'string',
            isCorporate: true,
            materials: [],
            cushioningMaterials: [],
            itemSpacing: {}
        },
        laborTiers: [],
        isLockedChanged: false
    };


    updateModifiersModel = {
        orderId: 0,
        itemContainerId: 0,
        quantity: 0,
        containerQuantity: 0,
        rubStripOrientationRegular: true,
        isCntQtyChanged: true,
        isExtendedCleat: true,
        skidOrientation: true,
        markupPercentage: 0,
        coverageRate: 0,
        innerDimension: {},
        outerDimension: {},
        itemContainerSummary: {},
        laborCalculation: {},
        modifiersLaborCalculation: {},
        itemContainerLabor: {},
        orderMaterials: [],
        floaterSummary: {
            laborCalculation: null,
            materials: [],
            laborCostType: null
        },
        palletSummary: {
            laborCalculation: null,
            materials: [],
            laborCostType: null
        },
        bottomDeckBoardSummary: {
            laborCalculation: null,
            materials: [],
            laborCostType: null
        },
        gussetsSummary: {
            laborCalculation: null,
            materials: [],
            laborCostType: null
        },
        fullPerpendicularRubStripsSummary: {
            laborCalculation: null,
            materials: [],
            laborCostType: null
        },
        containerDetails: {
            containerId: null,
            displayId: null,
            containerName: null,
            baseContainerId: null,
            minimumMinutes: null,
            customFixedLabour: null,
            defaultLabourMethod: null,
            isStockContainer: true,
            isActive: true,
            containerDetails: {}
        },
        laborTiers: [],
        isLockedChanged: false,
        floaterSpacing: {}
    };

    appointmentFormModel = {
        appointmentId: null,
        orderId: 0,
        orderGuid: null,
        orderDisplayId: null,
        appointmentTypeId: 1,
        employeeName: null,
        employeeId: 0,
        appointmentDate: null,
        startTime: null,
        endTime: null,
        contactName: '',
        contactId: 0,
        vehicleId: 0,
        vehicleName: null,
        driverId: 0,
        driverName: null,
        note: '',
        isNotifyEmployee: false
    };

    futureUseContainer = {
        containerId: 0,
        containerName: 'string',
        containerDetails: {
            floaterId: 0,
            palletId: 0,
            bottomDeckBoardId: 0,
            gussetsId: 0,
            fullPerpendicularRubStripsId: 0,
            cleatsId: 0,
            plywoodId: 0,
            skidOrientId: 0,
            notes: 'string'
        },
        containerMaterials: [],
        floaterMaterials: [],
        palletMaterials: [],
        bdbMaterials: [],
        gussetMaterials: [],
        fprsMaterials: []
    };

    orderAppointmentTimePickerSteps = {
        hour: null,
        minute: null,
        second: null
    };

    loggedUserModel = {
        email: null,
        userId: null,
        ownerId: null,
        ownerName: null,
        displayMode: null,
        displayName: null,
        startUpPage: null,
        accessToken: null,
        parentOwnerId: null,
        userPermission: null,
        defaultOwnerId: null,
        loggedInOwnerId: null,
        accountNumber: null,
        timezoneId: null,
        timezoneDescription: null,
        tenantId: null,
        tenantGuid: null,
        code: null,
        tGeocode: null,
        tZipcode: null,
        tFullAddress: null,
        roleId: null,
        tCity: null,
        tState: null,
        isFreightViewIntegrated: null,
        isShipmentOptionEnable: null,
        isJobSectionExpandCompress: null
    };

    accountService = {
        revenueCategoryId: null,
        markupPercentage: null,
        marginPercentage: null,
        isAvailableForAll: false,
        serviceId: null
    };

    orderExcessValueModel = {
        statusId: null,
        notes: null,
        orderId: null
    };

    orderExcessValueStatusModel = [
        { name: 'Open', id: 1 },
        { name: 'Pending', id: 2 },
        { name: 'Approved', id: 3 },
        { name: 'Rejected', id: 4 },
        { name: 'Canceled', id: 5 }
    ];

    ordersMaterailsListCollapsingStatesModel = {
        modifiers: {
            materials: true,
            floaterMaterails: true,
            floaterSpacing: true,
            palletMaterails: true,
            bdbMaterials: true,
            gussetsMaterials: true,
            frpsMaterials: true
        },
        packaging: {
            cushioning: true,
            nonCushioning: true,
            itemSpacing: true
        }
    };

    containerDimention = {
        height: null,
        length: null,
        weight: null,
        width: null
    };

    ordersFinalDimsRoutingModel = {
        trackingNumber: null,
        carrierId: null,
        carrierName: null,
        carrierUrl: null,
        pro: null,
        isLiftGate: false,
        shippingCost: 0,
        items: [],
        orderId: null,
        serviceName: null,
        serviceDate: null,
        isAutoFetchFinalDims: true,
        shipmentId: null,
        dimWeightFactorId: null,
        ancillariesDetails: null,
        originInstructions: null,
        destInstructions: null,
        destReferenceNumber: null,
        originReferenceNumber: null,
        pickupDate: null,
        currentQuote: {
            id: 0,
            pickupDate: null,
            shipFromReadyTime: null,
            shipFromCloseTime: null,
            shipToOpenTime: null,
            shipToCloseTime: null
        },
        isDataChange: false
    };

    ordersFinalDimsBOLModel = {
        quantity: 0,
        packageType: null,
        length: 0,
        width: 0,
        height: 0,
        description: null,
        weight: 0,
        nmfc: null,
        freightClass: null,
        unitDimentionWeight: 0,
        sortOrder: 0
    };

    ordersFinalDimsShippingDetailsModel = {
        shippingFrom: null,
        shippingTo: null
    };

    containerResetModel = {
        itemContainerId: 0,
        containerId: 0,
        orderId: 0,
        quantity: 0,
    };

    ordersBulkStatusUpdateModel = {
        orderId: [],
        statusId: 0,
        notes: null,
        statusName: null,
        oldStatusId: 0,
        oldStatusName: null,
        serviceTime: null,
        serviceDate: null,
        isLocked: true,
        isRejected: true
    };

    ordersAssignedToChangeModelData = {
        orderId: null,
        assignedTo: null,
        employeeName: null,
        notes: null
    };

    ordersBuildCompleteModelData = {
        statusId: null,
        orderId: null,
        employeeId: null,
        notes: null,
        isLock: true
    };

    ordersHoldModelData = {
        statusId: null,
        orderId: null,
        employeeId: null,
        notes: null,
        isLock: true
    };

    quickContactEditModel = {
        accountId: null,
        accountName: null,
        contactId: null,
        addressId: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        provinceId: null,
        province: null,
        zipCode: null,
        countryId: null,
        phone: null,
        isInternationalPhone: false,
        ext: null,
        email: null,
        firstName: null,
        lastName: null,
        provinceName: null,
        countryName: null,
        isInternational: false,
        IsConvertToLead: false,
        industryId: null,
        leadSourceId: null,
        alternateContacts: [],
        notes: null,
        addressIndicator: null
    };

    public jobsPermissionModel = {
        CreateJobs: false,
        UpdateJobs: false,
        ViewJobs: false,
        Jobs: false,
        DeleteJobs: false,
        QuickCutSheet: false,
        ExcessValue: false,
        JobsAppointments: false,
        Documents: false,
        MaterialList: false,
        JobsDocumentsAdminRequest: false,
        JobsDocumentsAdminRequestRequestForPrice: false,
        JobsDocumentsAdminRequestNotificationOfArrival: false,
        FinalizeJobs: false

    };

    public quotesPermissionModel = {
        CreateQuote: false,
        UpdateQuote: false,
        ViewQuote: false,
        DeleteQuote: false,
        Quotes: false,
        QuotesExcessValue: false,
        QuotesAppointments: false,
        QuotesDocuments: false,
        QuotesDocumentsAdminRequest: false,
        QuotesDocumentsAdminRequestRequestForPrice: false,
        QuotesDocumentsAdminRequestNotificationOfArrival: false,
        QuotesMaterialList: false
    };

    public shipmentsPermissionModel = {
        CreateShipments: false,
        UpdateShipments: false,
        ViewShipments: false,
        Shipments: false,
        DeleteShipments: false,
        ShipmentsQuickCutSheet: false,
        ShipmentsExcessValue: false,
        ShipmentsAppointments: false,
        ShipmentsDocuments: false,
        ShipmentsMaterialList: false,
        ShipmentsDocumentsAdminRequest: false,
        ShipmentsDocumentsAdminRequestRequestForPrice: false,
        ShipmentsDocumentsAdminRequestNotificationOfArrival: false,
    };


    public quickQuotesPermissionModel = {
        CreateQuickQuote: false,
        UpdateQuickQuote: false,
        ViewQuickQuote: false,
        DeleteQuickQuote: false,
        QuickQuotes: false
    };

    public accountPermissionModel = {
        ViewAccounts: false,
        ViewCustomer: false,
        ViewLead: false,
        ViewContacts: false,
    };

    public reportPermissionModel = {
        ViewReports: false,
        ViewReportsRoyaltyReport: false,
        ViewReportsMarketing: false,
        ViewReportsInsurance: false,
        ViewReportsJobs: false,
        ViewReportMyTerritory: false,
        ViewReportsISPMLumber: false
    };

    public adminPermissionModel = {
        ViewAdminDashboard: false,
        ViewAdminAccountDemographies: false,
        ViewAdminCreatingAndPackaging: false,
        ViewAdminDocuments: false,
        ViewAdminServiceAndInsurance: false,
        ViewAdminMyFrenchise: false,
        ViewAdminMyFrenchiseFrenchise: false,
        ViewAdminMyFrenchiseVehicles: false,
        ViewAdminEmployees: false,
        ViewAdminGroups: false,
        ViewAdminMyFrenchiseCorporate: false,
        ViewAdminServiceAndInsuranceInsurance: false,
        ViewAdminServiceAndInsuranceService: false,
        AdminCAndPContainers: false,
        AdminCAndPPackagings: false,
        AdminCAndPMaterials: false,
        AdminCAndPItems: false,
        Impersonate: false
    };

    public uploadBlockFilesExtensions = [
        '.exe',
        '.apk',
        '.app',
        '.ipa',
        '.webm',
        '.mpg',
        '.mp2',
        '.mpeg',
        '.mpe',
        '.mpv',
        '.ogg',
        '.mp4',
        '.m4p',
        '.m4v',
        '.avi',
        '.wmv',
        '.mov',
        '.qt',
        '.flv',
        '.swf',
        '.avchd',
        '.mkv',
        '.mwv',
        '.3gp',
        '.mp3',
        '.midi',
        '.m4a',
        '.ape',
        '.wav',
        '.mp2',
        '.acc',
        '.aac',
        '.vqf',
        '.amr',
        '.ra',
        '.3ga',
        '.ac3',
        '.ogg',
        '.flac',
        '.wma',
        '.aiff',
        '.asf'
    ];

    withoutPaginationReportsGridModel = {
        data: [],
        total: 0
    };

    shippingUnitObject = {
        id: null,
        shippingUnit: 0,
        length: 0,
        width: 0,
        height: 0,
        description: '',
        weightLbs: 0
    };

    acconutTaxCondifurationModel = {
        material: false,
        labor: false,
        services: false,
        shipping: false,
        insurance: false,
        salesTaxPercentage: null,
        accountTaxConfigurationId: null,
        accountId: null,
        isTaxConfigure: false
    };

    ordersCarrierStatusChangeModel = {
        trackingNumber: null,
        carrierId: null,
        carrierName: null,
        carrierUrl: null,
        carrierPhone: null,
        isLiftGate: false,
        shippingCost: 0,
        orderId: null,
        statusId: null,
        notes: null,
        statusName: null,
        isLocked: true,
        items: [],
        serviceName: null,
        serviceDate: null,
        serviceTime: null,
        date: null,
        time: null,
        shipper: null,
        consignee: null,
        pro: null
    };

    getCommonCarrierClass = [
        { label: '55', value: '55' },
        { label: '60', value: '60' },
        { label: '65', value: '65' },
        { label: '70', value: '70' },
        { label: '77.5', value: '77.5' },
        { label: '85', value: '85' },
        { label: '92.5', value: '92.5' },
        { label: '100', value: '100' },
        { label: '110', value: '110' },
        { label: '125', value: '125' },
        { label: '150', value: '150' },
        { label: '175', value: '175' },
        { label: '200', value: '200' },
        { label: '250', value: '250' },
        { label: '300', value: '300' },
        { label: '400', value: '400' },
        { label: '500', value: '500' },
    ];

    documentsNavigationModel = [
        { id: 1, label: 'Publish Documents', isActive: true, url: 'null' },
        { id: 2, label: 'Admin Request', isActive: false, url: 'admin-request' },
        { id: 3, label: 'Upload Documents', isActive: false, url: 'uploaded' },
        { id: 4, label: 'All Documents', isActive: false, url: 'all' }
    ];

    dateRangeModel = {
        start: null,
        end: null
    };

    appointmentDetailsModel = {
        id: 0,
        appointmentId: null,
        orderId: null,
        isJob: null,
        displayId: '',
        appointmentTypeName: '',
        startTime: null,
        endTime: null,
        labelName: '',
        durationTime: '',
        containerDetails: '',
        itemsCount: 0,
        itemsTotal: 0,
        contactName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        province: '',
        zipCode: '',
        country: '',
        phone: ''
    };

    acconutParticipantsCondifurationModel = {
        accountId: null,
        isParticipantsConfigure: false
    };

    documentConfigModel = {
        body: '',
        houseBillTotal: 0,
        houseBillTypeId: 0,
        insuranceRateId: 0,
        intermediateEmail: '',
        meEmail: '',
        orderId: '',
        payerEmail: '',
        quoteNotes: '',
        shipFromEmail: '',
        shipToEmail: '',
        shippingLabel: '',
        subject: ''
    };

    accountDataModel = {
        accountId: null,
        accountName: '',
        contactId: null,
        contactName: '',
        displayId: '',
        isParticipantsConfigure: false,
        suffix: ''
    };

    dropdownDatModel = {
        id: null,
        name: null,
        description: null
    };

    appointmentTypesModel = {
        id: null,
        css: null,
        icon: null,
        isSelected: null,
        label: null,
        type: null,
        name: null,
    };

    getHouseBillTotalTypes() {
        return [
            { label: 'None', value: 1 },
            { label: 'Total Only', value: 2 },
            { label: 'Total And Sub Categories', value: 3 },
        ];
    }

    getroyaltyAdFundTypes() {
        return [
            { label: '3 & .6 Royalty Plan', value: 1 },
            { label: 'Corporate 0 Plan', value: 2 },
            { label: '3 & .5 Royalty Plan', value: 3 },
            { label: '5 & 1 Royalty Plan', value: 4 },
            { label: '3 & 1 Royalty Plan', value: 5 },
        ];
    }

    geCarrierClass() {
        return [
            { label: '55', value: 1 },
            { label: '60', value: 2 },
            { label: '65', value: 3 },
            { label: '70', value: 4 },
            { label: '77.5', value: 5 },
            { label: '85', value: 6 },
            { label: '92.5', value: 7 },
            { label: '100', value: 8 },
            { label: '110', value: 9 },
            { label: '125', value: 10 },
            { label: '150', value: 11 },
            { label: '175', value: 12 },
            { label: '200', value: 13 },
            { label: '250', value: 14 },
            { label: '300', value: 15 },
            { label: '400', value: 16 },
            { label: '500', value: 17 },
        ];
    }

    getPkgType() {
        return [
            { label: 'Crate (default)', value: 1 },
            { label: 'Pallet 48" x 40"', value: 2 },
            { label: 'Pallet - Custom', value: 3 },
            { label: 'Boxes', value: 4 },
            { label: 'Units', value: 5 },
        ];
    }

    proNumberDataModel = {
        orderId: '',
        pro: ''
    }

    forumPermissionModel = {
        ForumsandQuickLinks: false
    }

    contactMigrationPayload = {
        contact: null,
        account: null,
        displayId: null,
        fullName: null,
        accountName: null,
        contactId: null,
        accountId: null,
        migratedTenantId: null,
        emailOrPhone: null,
        isMigrateContactWithAddress: false,
    }
}
